export const FormComputedValueMixin = {
  emits: ['input'],
  props: {
    value: { type: [Object, String, Number, Boolean, Array] }
  },
  data() {
    return {
      localComputedValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.localComputedValue = newVal;
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.localComputedValue;
      },
      set(value) {
        if (value !== this.localComputedValue) {
          this.localComputedValue = value;
          this.$emit('input', value);
        }
      }
    }
  }
};
